import Vue from 'vue';
import {
  SET_TEAM_SETTING_OVERRIDE_UI_FLAG,
  SET_TEAM_SETTING_OVERRIDE,
  DELETE_TEAM_SETTING_OVERRIDE,
} from './types';

export const mutations = {
  [SET_TEAM_SETTING_OVERRIDE_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },

  [SET_TEAM_SETTING_OVERRIDE]: ($state, { teamId, data }) => {
    Vue.set($state.records, teamId, data || null);
  },

  [DELETE_TEAM_SETTING_OVERRIDE]: ($state, teamId) => {
    const records = { ...$state.records };
    delete records[teamId];
    Vue.set($state, 'records', records);
  },
};
